module.exports = __webpack_public_path__ + "img/location.c4ec3eb.webp";